export default {
    show: function (name) {
        let el = document.getElementById(name);

        if (el !== null) {
            let vueInstance = el.__vue__;

            setTimeout(() => {
                if (Object.prototype.hasOwnProperty.call(vueInstance, 'visibility')) {
                    vueInstance.$emit('beforeOpen');
                    vueInstance.visibility = true;
                } else {
                    vueInstance.$children[0].$emit('beforeOpen');
                    vueInstance.$children[0].visibility = true;
                }
            }, 10);
        }
    },
    hide: function (name) {
        let el = document.getElementById(name);

        if (el !== null) {
            let vueInstance = el.__vue__;

            if (Object.prototype.hasOwnProperty.call(vueInstance, 'visibility')) {
                if (vueInstance.visibility) {
                    vueInstance.visibility = false;
                    vueInstance.$emit('afterHide');
                }
            } else {
                if (vueInstance.$children[0].visibility) {
                    vueInstance.$children[0].visibility = false;
                    vueInstance.$children[0].$emit('afterHide');
                }
            }
        }
    }
};
